/** Тексты вне paywall: лимиты Premium, подсказки полей. */

export const PREMIUM_CHAT_LIMIT_TITLE = "Сегодня лимит подборов исчерпан 🙌";

export const PREMIUM_CHAT_LIMIT_BODY =
  "Вы уже использовали доступное количество генераций на сегодня.\nЛимит обновится завтра — спасибо, что пользуетесь приложением.";

export const PREMIUM_HELP_LIMIT_TITLE = "Сегодня вы уже получили помощь 🙌";

export const PREMIUM_HELP_LIMIT_BODY =
  "Вы уже использовали доступное количество запросов на сегодня.\nЛимит обновится завтра — спасибо, что пользуетесь приложением.";

export const PREMIUM_PROFILES_MAX_TITLE = "Места для профилей больше нет";

export const PREMIUM_PROFILES_MAX_BODY =
  "В полной версии можно создать до 7 профилей.\nЧтобы добавить нового члена семьи, удалите один из существующих.";

export const FREE_ALLERGY_PAYWALL_MESSAGE =
  "В бесплатной версии — одна аллергия\nВ полной — учитываем всё питание ребёнка без риска";

export const FREE_ALLERGY_SINGLE_HINT_CREATE =
  "На бесплатном плане в профиле можно указать одну аллергию. Список можно изменить позже в карточке профиля.";

/** После добавления одной аллергии на Free (поле заблокировано). */
export const FREE_ALLERGY_LIMIT_REACHED_HINT =
  "Указана одна аллергия — лимит бесплатного плана. Удалите чип, чтобы заменить.";

export const FREE_ALLERGY_UPSELL_LINK_LABEL = "Несколько аллергий — в полной версии";
